import {mdiEye, mdiEyeOff} from "@mdi/js";
import _ from "lodash";

const logger = log4javascript.getLogger('app');
logger.addAppender(new log4javascript.BrowserConsoleAppender());
const parseFunctionName = (stack) => {
    if (!stack) return 'unknown';
    const match = stack.match(/at\s+([^\s(]+)/);
    return match ? match[1] : 'anonymous';
};

const error_miss = ['jqueryts.min.js:21:2500', 'uimanager.js:118:8']
export const logError = async (data) => {
    try {
        if (window.config.js_debug) console.error(data)
        const errorBase = (data instanceof Error) ? {
            type: data.name || 'Error',
            message: data.message,
            functionName: data.functionName || parseFunctionName(data.stack),
            stack: data.stack
        } : data;
        const errorData = {
            ...errorBase,
            functionName: errorBase.functionName || parseFunctionName(errorBase.stack),
            stack: Array.isArray(errorBase.stack)
                ? errorBase.stack
                : errorBase.stack?.split('\n') || [],
            url: window.location.href,
            userAgent: navigator.userAgent,
            timestamp: new Date().toISOString()
        };

        await jqueryts.ajax()
            .headers({'Content-Type': 'application/json'})
            .post(`/${lang}/err/js`, errorData)
            .fail(function (xhr) {
                console.error('Ошибка отправки лога на сервер:', xhr.status, xhr.statusText);
                console.error('Response:', xhr.responseJSON || xhr.responseText);
            });
    } catch (e) {
        console.error('Не удалось отправить лог ошибки', e);
    }
};


export const logErrorUser = async (data) => {
    try {
        data.type=data.name || 'Log Error User'
        data.message= data.message || 'message null'
        data.functionName= data.functionName || 'functionName null'
        data.stack= data.stack || 'functionName null'
        data.url=window.location.href
        data.userAgent=navigator.userAgent
        data.timestamp= new Date().toISOString()

        await jqueryts.ajax()
            .headers({'Content-Type': 'application/json'})
            .post(`/${lang}/err/js`, errorData)
            .fail(function (xhr) {
                if (window.config.js_debug) console.error('Ошибка отправки лога на сервер:', xhr.status, xhr.statusText);
                if (window.config.js_debug) console.error('Response:', xhr.responseJSON || xhr.responseText);
            });
    } catch (e) {
        if (window.config.js_debug) console.error('Не удалось отправить лог ошибки', e);
    }
};

function shouldIgnoreError(error) {
    if (!error?.stack) return false;
    return error.stack.split('\n').some(str =>
        error_miss.some(code => str.includes(code))
    );
}

window.addEventListener('unhandledrejection', async (event) => {
    if (window.config.js_debug) logger.warn("TYPE ERR: ============> window.addEventListener unhandledrejection")

    const reason = event.reason;
    const err = new Error(reason?.message || String(reason));
    Error.captureStackTrace(err, window.addEventListener);
    const stackLines = err.stack.split('\n');
    if (reason?.stack) {
        stackLines.push(...reason.stack.split('\n'));
    }
    try {
        await logError(reason);
    } catch (e) {
        console.error('logError failed:', e);
    }
    return true;
});

window.addEventListener('error', (event) => {
    try {
        if (window.config.js_debug) logger.info("TYPE ERR: ============> window.addEventListener error");
        if (shouldIgnoreError(event.error)) {
            if (window.config.js_debug) logger.warn('Ignored error');
            event.preventDefault()
            return true;
        }
        const target = event.target;
        logError(event.error);
    } catch (e) {
        if (window.config.js_debug)
            logger.error(e)
    }

}, true);


export const lang = document.querySelector('html').getAttribute('lang');

/**
 * Ширины диалогов для модальных окон
 * @type {number}
 */
let win_with_data = 550;
try {
    if (document.body.offsetWidth < 560) {
        win_with_data = document.body.offsetWidth - 20
    }
} catch (e) {
    logError(e);
}
export let win_with = win_with_data;

/**
 * Рест запрос типа GET
 * @param request
 * @param schema
 * @param id
 * @param client
 * @returns {*}
 */
export function GET(request, schema = "public", id = false) {
    return jqueryts.ajax().headers({
        "Accept-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).get(`/${lang}/api/${request}`)
        .then(res => {
            try {
                res = res.json()
                if (id) {
                    res.map(obj => {
                        obj.id = obj[id]
                        return obj
                    });
                }
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'GET', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'GET',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}


/**
 * Рест запрос типа хранимых процедур
 * @param request
 * @param data
 * @param schema
 * @param id
 * @returns {*}
 */
export function POSTR(request, data, schema = "public", id = false) {
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).post(`/${lang}/api/rpc/${request}`, data)
        .then(res => {
            try {
                res = res.json()
                if (id) {
                    res.map(obj => {
                        obj.id = obj[id]
                        return obj
                    });
                }
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'POSTR', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'POSTR',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}


export function POST(request, data, schema = "public", id = false) {
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "Prefer": "return=representation",
        "X-Custom-Ajax": `true`
    }).post(`/${lang}/api/${request}`, data)
        .then(res => {
            try {
                res = res.json()
                if (id) {
                    res.map(obj => {
                        obj.id = obj[id]
                        return obj
                    });
                }
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'POST', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'POST',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}

/**
 * Рест запрос типа PUT
 * @param request
 * @param data
 * @param schema
 * @returns {*}
 */
export function PUT(request, data, schema = "public") {
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).put(`/${lang}/api/${request}`, data)
        .then(res => {
            try {
                res = res.json()
                return res
            } catch (e) {
                logError(e);
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'PUT',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}

/**
 * Рест запрос типа PATCH
 * @param request
 * @param data
 * @param schema
 * @returns {*}
 */
export function PATCH(request, data, schema = "public") {
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).patch(`/${lang}/api/${request}`, data)
        .then(res => {
            try {
                res = res.json()
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'PATCH', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'PATCH',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}

/**
 * Рест запрос типа DELETE
 * @param request
 * @param schema
 * @returns {*}
 */
export function DELETE(request, schema = "public") {
    return jqueryts.ajax().headers({
        "Content-Profile": `${schema}`,
        "X-Custom-Ajax": `true`
    }).del(`/${lang}/api/${request}`)
        .then(res => {
            try {
                res = res.json()
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'DELETE', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'DELETE',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}


/**
 * Запрос типа POST для функций PHP
 * @param request
 * @param data
 * @returns {*}
 */
export function POSTP(request, data) {
    return jqueryts.ajax()
        .headers({
            "X-Custom-Ajax": `true`
        }).post(`/${lang}/${request}/`, data)
        .then(res => {
            try {
                res = res.json()
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'POSTP', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            let text = `
<b>${_t('Ошибка сервера.')} ${_t('Код')}: ${xhr.status}.</b> 
<br>${_t('Обратитесь к администратору, указав код ошибки')}`
            switch (xhr.status) {
                case 400:
                    text = `
<b>${_t('Ошибка сервера.')} ${_t('Код')}: ${xhr.status}.</b>
<br>${_t('Запрос заблокирован системой защиты.')}
<br>${_t('Обратитесь к администратору, указав код ошибки')}\`
`
                    break;
            }
            jqueryts.message({
                type: "error",
                expire: -1,
                text: text
            })
            logError({
                type: 'API Error',
                functionName: 'POSTP',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseText, data:JSON.stringify(data)}
            });
            throw xhr;
        }).fail(err=>{
            console.error(err)
        });
}


/**
 * Запрос типа GET для функций PHP
 * @param request
 * @returns {*}
 */
export function GETP(request) {
    return jqueryts.ajax()
        .headers({
            "X-Custom-Ajax": `true`
        }).get(`/${lang}/${request}`)
        .then(res => {
            try {
                res = res.json()
                return res
            } catch (e) {
                logError({type: 'Parse Error', functionName: 'GETP', request, error: e});
                throw e;
            }
        })
        .catch(xhr => {
            logError({
                type: 'API Error',
                functionName: 'GETP',
                request,
                xhr: {status: xhr.status, statusText: xhr.statusText, response: xhr.responseJSON || xhr.responseText}
            });
            throw xhr;
        });
}

const icon_eye = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#ccc" d="${mdiEye}"/></svg>`
const icon_eye_off = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#ccc" d="${mdiEyeOff}"/></svg>`


export function toggleButtonPassw_v2(input) {
    try {
        const inputEl = $$(input);
        if (!inputEl || !inputEl.config) {
            logger.error('toggleButtonPassw_v2: Input element not found:', input);
            return;
        }

        const node = inputEl.getNode();
        if (!node || typeof node.className !== 'string') {
            logger.error('toggleButtonPassw_v2: Invalid container element:', input);
            return;
        }
        const cssText = `cursor: pointer;position: absolute;right: 10px;top: 0px;transform: translateY(50%);z-index: 10;width: 30px;height: 30px;display: block;`
        const isPassword = inputEl.config.type === 'password';
        const iconHtml = isPassword ? icon_eye : icon_eye_off;

        let eyeBtn = node.querySelector('.password-eye-btn');
        if (!eyeBtn) {
            eyeBtn = document.createElement('span');
            eyeBtn.className = 'password-eye-btn';
            eyeBtn.innerHTML = iconHtml;

            eyeBtn.style.cssText = cssText;
            eyeBtn.addEventListener('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                see_passw_v2(input);
            });
            node.style.position = 'relative';
            node.appendChild(eyeBtn);
        } else {
            eyeBtn.innerHTML = iconHtml;
        }
    } catch (e) {
        logError(e);
    }
}


function see_passw_v2(input) {
    try {
        const inputEl = $$(input);
        if (!inputEl || !inputEl.config) {
            return;
        }

        if (inputEl.config.type === 'password') {
            inputEl.define('type', 'text');
            inputEl.refresh();
        } else {
            inputEl.define('type', 'password');
            inputEl.refresh();
        }

        toggleButtonPassw_v2(input);
    } catch (e) {
        logError(e);
    }
}



export function route_parse() {
    try {
        return window.location.pathname.split("/")
    } catch (e) {
        logError(e);
        return [];
    }
}


export function _t(index) {
    try {
        if (!window.translate) return index
        const el = window.translate.getItem(index)
        if (el === undefined) return index
        return el[lang]
    } catch (e) {
        logError(e);
        return index;
    }
}


export function onloadCapatcha(id) {
    try {
        if (window.smartCaptcha) {
            const container = document.getElementById(id);
            const widgetId = window.smartCaptcha.render(container, {
                sitekey: window.config.captcha.sitekey,
                hl: (lang === 'ru') ? 'ru' : 'en',
                robustness: 'default'
            });
        }
    } catch (e) {
        logError(e);
    }
}


export const treeBuild = (list, id, pid, debug = false) => {
    try {
        var map = {}, node, roots = [], i;
        for (i = 0; i < list.length; i += 1) {
            map[list[i][id]] = i; // initialize the map
            list[i].data = []; // initialize the children
        }
        for (i = 0; i < list.length; i += 1) {
            node = list[i];
            if (node[pid] !== null) {
                let level = node[pid]
                if (node[pid] === node[id]) level = node[id]
                if (level === null) level = 0
                if (debug) {
                    try {
                        list[map[level]].data.push(node);
                    } catch (e) {
                        logError(e)
                    }
                } else {
                    list[map[level]].data.push(node);
                }

            } else {
                roots.push(node);
            }
        }
        return roots;
    } catch (err) {
        logError(err)
    }
}


/**
 * создание id
 * @param list
 * @param id
 * @param debug
 * @returns {(*&{id: *})[]}
 */
export const ids = (list, id, debug = false) => {
    try {
        const newList = _.map(list, obj => {
            return {...obj, id: obj[id]};
        });
        return newList
    } catch (e) {
        logError(e);
        return list;
    }
}

export function init_blur_reg(label) {
    try {
        $(label).find("input").on('focus', function () {
            $(this).parent().parent().addClass("focus")
        })
        $(label).find("input").on('blur', function () {
            if ($(this).val().trim(" ") === "")
                $(this).parent().parent().removeClass("focus")
        })
    } catch (e) {
        logError(e)
    }
}

/**
 * Вернет строку с форматно выведенным размером в удобной для чтения форме
 * @param bytes
 * @returns {string}
 */
export function formatBytes(bytes) {
    try {
        if (bytes === 0) return '0 Bytes';

        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    } catch (e) {
        logError(e);
        return '0 Bytes';
    }
}

export function mdi(icon, color = '#ccc') {
    try {
        return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="${color}" d="${icon}"/></svg>`
    } catch (e) {
        logError({type: 'MDI Error', icon, color, error: e});
        return '';
    }
}


